import { modalModes } from 'utils/constants';
import InfoIcon from 'assets/icons/help.svg';
import MailIcon from 'assets/icons/subscribe.svg';
import ResetIcon from 'assets/icons/reset-green.svg';
import TextField from 'components/TextField';
import { isEmail } from 'validator';
import { FooterProps } from 'interfaces/components/dataEntryModal/Footer';
import RetentionTooltip from 'components/RetentionTooltip';
import { useAuth } from 'context/AuthContext';
import Button from 'components/Button';

const Footer = ({
  mode,
  isApplyDisabled,
  isUpdateDisabled,
  onApply,
  onUpdate,
  email,
  onChangeEmail,
  isSubmitting,
  onClearForm
}: FooterProps) => {
  const { isAuthenticated } = useAuth();

  return (
    <div className='sticky bottom-0 w-full flex flex-col items-end justify-between mt-auto px-8 py-6 border-t border-gray-400 dark:border-gray-800 border-solid'>
      <div className='w-full flex flex-row items-center justify-between'>
        <div
          className='flex flex-row items-center gap-1 cursor-pointer'
          onClick={onClearForm}
        >
          <img src={ResetIcon} alt='' />
          <p className='text-[18px] leading-[19.2px] text-green-700 font-light'>
            Clear Form
          </p>
        </div>
        <div className='flex items-center gap-6 w-[730px]'>
          <div>
            <p className='text-[13px] leading-[24px] text-justify font-light text-gray-500'>
              Share your contact information below to overlay your data. By
              entering your data, you consent to{' '}
              <span
                className='text-[13px] font-semibold leading-[24px] cursor-pointer border-b border-gray-500'
                data-tooltip-id='retention_tooltip'
                data-tooltip-place='top'
              >
                ICONIQ's data retention policy.
              </span>{' '}
              <RetentionTooltip />
            </p>
          </div>
          {isAuthenticated &&
            (mode === modalModes.ADD ? (
              <Button
                id='applyComparisonData'
                name='apply'
                label={isSubmitting ? 'Saving...' : 'Submit'}
                onClick={onApply}
                disabled={isApplyDisabled() || isSubmitting}
                className='px-4 py-2 rounded-full bg-black dark:bg-white dark:border dark:border-gray-400 text-white dark:text-black cursor-pointer hover:opacity-70 transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50'
              />
            ) : (
              <Button
                id='updateComparisonData'
                name='update'
                label={isSubmitting ? 'Saving...' : 'Update'}
                onClick={onUpdate}
                disabled={isApplyDisabled() || isSubmitting}
                className='px-4 py-2 rounded-full bg-black dark:bg-white dark:border dark:border-gray-400 text-white dark:text-black cursor-pointer hover:opacity-70 transition-all duration-200 disabled:cursor-not-allowed disabled:opacity-50'
              />
            ))}
          {!isAuthenticated &&
            (mode === modalModes.ADD ? (
              <div className='w-full max-w-[360px]'>
                <TextField
                  id='applyComparisonData'
                  name='apply'
                  value={email}
                  onChange={onChangeEmail}
                  icon={MailIcon}
                  buttonLabel={isSubmitting ? 'Saving...' : 'Submit'}
                  onClick={onApply}
                  placeholder='Enter your email'
                  disabled={isApplyDisabled() || isSubmitting}
                  disableInput={isAuthenticated}
                  tooltip={{
                    id: 'add_tooltip',
                    content:
                      'Please enter your email address to submit this form and overlay your data against our software benchmarks.',
                    icon: InfoIcon
                  }}
                  className='walkthrough-email'
                  inputClassName={`${email ? 'w-full' : 'w-[120px]'}`}
                />
              </div>
            ) : (
              <div className='w-full max-w-[400px]'>
                <TextField
                  id='updateComparisonData'
                  name='update'
                  value={email}
                  onChange={onChangeEmail}
                  icon={MailIcon}
                  buttonLabel={isSubmitting ? 'Saving...' : 'Update'}
                  onClick={onUpdate}
                  placeholder='Enter your email'
                  disabled={isUpdateDisabled() || isSubmitting}
                  disableInput={isAuthenticated}
                  tooltip={{
                    id: 'update_tooltip',
                    content:
                      'Please enter your email address to submit this form and overlay your data against our software benchmarks.',
                    icon: InfoIcon
                  }}
                  className='walkthrough-email'
                  inputClassName={`${email ? 'w-full' : 'w-[120px]'}`}
                />
              </div>
            ))}
        </div>
      </div>
      {email && !isEmail(String(email)) && (
        <p className='text-xs font-light'>Invalid email entered</p>
      )}
    </div>
  );
};

export default Footer;
